import { withAITracking } from '@microsoft/applicationinsights-react-js';
import { reactPlugin } from '../AppInsights';

/**
 * Wrapper seguro para withAITracking que verifica se reactPlugin é null
 * antes de tentar usar seus métodos, evitando erros durante componentWillUnmount
 */
export const safeWithAITracking = (plugin, component, componentName, componentId) => {
    // Se reactPlugin é null, retornar o componente sem tracking
    if (!plugin || plugin === null) {
        return component;
    }
    
    // Se reactPlugin existe, usar withAITracking normalmente
    try {
        return withAITracking(plugin, component, componentName, componentId);
    } catch (error) {
        console.warn('Error applying AI tracking, using component without tracking:', error);
        return component;
    }
};

